import { CeilingPlane, ModelCategory } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';

export const CeilingPlaneSchema = new ModelSchema<CeilingPlane>('ceilingPlane', {
  category: ModelCategory.IntermediateModel,

  properties: {},
  children: {},
});
